<template>
    <div>
        <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>
        <div class="container-fluid mt--9">
          <div class="row" v-if="!showLoader">
            <div class="col-sm-4" style="padding-top:10px" v-for="kpi in kpis" v-bind:key="kpi.name">
                <div class="card shadow">
                    <div class="card-header bg-transparent">
                        <h3 class="mb-0">{{ kpi.name }}</h3>
                    </div>
                    <div class="card-body">
                      <center>
                        <h4 class="text-muted"> Semana {{ moment().week() }}</h4>
                        <h5 class="text-muted"> {{ moment().startOf('week').add(1, 'days').format('YYYY/MM/DD') }} - {{ moment().endOf('week').format('YYYY/MM/DD') }}</h5>
                      </center>
                      <div class="row" style="padding-top:10px;">
                        <div class="col-sm-4">
                          <label for="Planeado" class="text-muted text-sm">Cant. <br>Planeada</label>
                          <h4 v-if="kpi.status == 'completed'">{{ kpi.planeado }}</h4>
                          <base-input class="input-group-alternative mb-3"
                            placeholder="Planeado"
                            v-if="kpi.status=='pending'"
                            v-model="kpi.planeado">
                          </base-input>
                        </div>
                        <div class="col-sm-4">
                          <label for="Planeado" class="text-muted text-sm">Cant. <br>Producida</label>
                          <h4 v-if="kpi.status == 'completed'">{{ kpi.producido }}</h4>
                          <base-input class="input-group-alternative mb-3"
                            placeholder="Producido"
                            v-if="kpi.status=='pending'"
                            v-model="kpi.producido">
                          </base-input>
                        </div>
                        <div class="col-sm-4">
                          <label for="Planeado" class="text-muted text-sm">Cant. <br>Merma</label>
                          <h4 v-if="kpi.status == 'completed'">{{ kpi.merma }}</h4>
                          <base-input class="input-group-alternative mb-3"
                            placeholder="Merma"
                            v-if="kpi.status=='pending'"
                            v-model="kpi.merma">
                          </base-input>
                        </div>
                      </div>
                      <center v-if="kpi.loading" style="padding-bottom:10px"><img src="img/loader.gif" class="img-responsive" style="width:50px;padding-bottom:5px;padding-top:13px"><br>Guardando...</center>
                      <base-button v-if="!kpi.loading && kpi.status=='pending'" block @click="guardarKPI(kpi)" disabed="true">Guardar</base-button>
                    </div>
                </div>
            </div>
          </div>
          <div v-else>
            <center><img src="img/loader.gif" class="img-responsive" style="width:50px;padding-bottom:5px;padding-top:13px"><br>Cargando KPI's...</center>
          </div>
        </div>
    </div>
</template>
<script>
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import axios from 'axios';
  import moment from 'moment'
  
  Vue.use(VueClipboard)
  export default {
    directives: {
      'b-tooltip': BTooltipDirective
    },
    beforeMount(){
      this.cargarKPIs()
    },
    data() {
      return {
        tableData: [],
        showLoader: true,
        kpis:[
          {
            "name":"CONTADORAS",
            "planeado":null,
            "producido":null,
            "merma":null,
            "loading":false,
            "status":"pending"
          },
          {
            "name":"CORTADORAS ByM",
            "planeado":null,
            "producido":null,
            "merma":null,
            "loading":false,
            "status":"pending"
          },
          {
            "name":"ENGOMADORA MASTER",
            "planeado":null,
            "producido":null,
            "merma":null,
            "loading":false,
            "status":"pending"
          },
          {
            "name":"ENGOMADORAS TIRAS",
            "planeado":null,
            "producido":null,
            "merma":null,
            "loading":false,
            "status":"pending"
          },
          {
            "name":"CORTADORA BARBERAN",
            "planeado":null,
            "producido":null,
            "merma":null,
            "loading":false,
            "status":"pending"
          },
          {
            "name":"TEXTURIZADORA",
            "planeado":null,
            "producido":null,
            "merma":null,
            "loading":false,
            "status":"pending"
          }
        ],
      }
    },
    methods:{
      cargarKPIs(){
        this.showLoader = true;
        axios.get(`/api/production_metrics/date?year=${moment().year()}&week=${moment().week()}`)
        .then((response) => {
          response.data.value.forEach(kpi => {
            this.kpis.find(k => k.name == kpi.U_MachineName).planeado = kpi.U_ScheduledQty;
            this.kpis.find(k => k.name == kpi.U_MachineName).producido = kpi.U_ProducedQty;
            this.kpis.find(k => k.name == kpi.U_MachineName).merma = kpi.U_Merma;
            this.kpis.find(k => k.name == kpi.U_MachineName).status = 'completed'
          });
          this.showLoader = false;
        })
      },
      guardarKPI(kpi){
        this.kpis.find(k => k.name == kpi.name).loading = true;
        let body = {
          "U_MachineName": kpi.name,
          "U_Week": moment().week(),
          "U_ScheduledQty": kpi.planeado,
          "U_ProducedQty": kpi.producido,
          "U_Merma": kpi.merma,
          "U_Year": moment().year()
        }
        axios.post(`/api/production_metrics`,body).then((response) => {
          this.cargarKPIs()
          this.kpis.find(k => k.name == kpi.name).loading = false;
        })
      },
      moment: function () {
        return moment();
      }
    }
  };
</script>
<style></style>
